<div>
    <div class="nav_container" 
    [ngClass]="{
        'background-net': _Platform == _PlatformEnum.NET, 
        'background-com': _Platform == _PlatformEnum.US, 
        'background-eu': _Platform == _PlatformEnum.EU}">
        <span class="title" routerLink="/" *ngIf="_Platform == _PlatformEnum.EU">AMADEO PLATFORM - DEVELOPMENT</span>
        <span class="title" routerLink="/" *ngIf="_Platform == _PlatformEnum.NET">AMADEO PLATFORM - SALES</span>
        <span class="title" routerLink="/" *ngIf="_Platform == _PlatformEnum.US">AMADEO PLATFORM</span>
        <ul>
            <!-- <li class="navigation_item">
                <a routerLink="/login/1145" routerLinkActive="active">Login</a>
            </li> -->
            <li class="navigation_item">
                <a routerLink="/register" routerLinkActive="active">Register</a>
            </li>
        </ul>
    </div>
    <div class="content">
        <router-outlet></router-outlet>
    </div>

    <div class="clear"></div>
    <div class="footer" [class.hide_footer]="hideFooter"
        [ngClass]="{
            'background-net': _Platform == _PlatformEnum.NET, 
            'background-com': _Platform == _PlatformEnum.US, 
            'background-eu': _Platform == _PlatformEnum.EU}">
        <div class="row">
            <div class="col-3 footer-text footer-text-left">
                <a routerLink="/impressum">Impressum</a>
            </div>
            <div class="col-6 footer-text">
                &copy; {{ year }} AMADEO Systems GmbH
            </div>
            <div class="col-3 footer-text footer-text-right">
                <a href="http://www.amadeosystems.com/privacy-policy" target="_blank">Privacy Policy</a>
            </div>
        </div>
    </div>
</div>
